import { updateDoc } from "firebase/firestore";
import { Box, Button, Modal } from "native-base";
import React, { useCallback, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { useFirestore } from "../../../hooks/useFirestore.web";
import BulkActionButton from "./BulkActionButton";
import { ProtocolTimestampAction } from "./ObjectBulkActions";

import "react-datepicker/dist/react-datepicker.css";

import de from "date-fns/locale/de";
registerLocale("de", de);

interface BulkActionSetProtocolTimestampsProps {
  action: ProtocolTimestampAction | string;
  title: string;
  projectId: string;
  objectIds: string[];
}

export default function BulkActionSetProtocolTimestamps({
  action,
  title,
  projectId,
  objectIds,
}: BulkActionSetProtocolTimestampsProps) {
  const [isLoading, setLoading] = useState(false);

  const [isModalShown, setModalShown] = useState(false);

  const showModal = useCallback(() => {
    setModalShown(true);
  }, [setModalShown]);

  const onClose = useCallback(() => {
    setModalShown(false);
  }, [setModalShown]);

  const [date, setDate] = useState<Date | null>(new Date());

  const [_tenantId, _store, doc] = useFirestore();

  const performAction = useCallback(async () => {
    setLoading(true);

    for (const objectId of objectIds) {
      const docPath = ["projects", projectId, "objects", objectId].join("/");
      await updateDoc(doc(docPath), {
        [action]: date,
      });
    }

    setLoading(false);
    onClose();
  }, [action, onClose, setLoading, projectId, objectIds, doc, date]);

  return (
    <>
      <BulkActionButton
        onPress={showModal}
        isDisabled={isLoading || objectIds.length === 0}
      />

      <Modal isOpen={isModalShown} onClose={onClose}>
        <Modal.Content width={600}>
          <Modal.CloseButton />

          <Modal.Header>{title}</Modal.Header>

          <Modal.Body alignItems="center">
            <Box display="inline-block">
              <DatePicker
                selected={date}
                onChange={setDate}
                placeholderText="Datum wählen"
                locale="de"
                dateFormat="P"
                popperClassName="vermflex-popover"
                portalId="datepicker-portal"
                inline
              />
            </Box>
          </Modal.Body>

          <Modal.Footer>
            <Button.Group space={2}>
              <Button onPress={performAction} isLoading={isLoading}>
                Aktion ausführen
              </Button>
            </Button.Group>
          </Modal.Footer>
        </Modal.Content>
      </Modal>
    </>
  );
}
